<!-- 队伍信息展示 -->
<template>
  <div :class="$style['team-info']">
    <template v-if="teamName">
      <h2>
        {{ teamName }}<span>{{ teamSlogan }}</span>
      </h2>
      <div :class="$style['team-list']">
        <icon-text
          v-for="index in 5"
          :key="index"
          size="sm"
          :icon="
            teamMemberList[index - 1] &&
            require(`./images/avatars/avatar-${teamMemberList[index - 1].head_pic}.png`)
          "
          :text="teamMemberList[index - 1] && teamMemberList[index - 1].role_name"
        />

        <!-- 队伍邀请功能 -->
        <invite-link
          v-if="teamMemberList.length !== 5"
          style="position: absolute; top: -0.05rem; right: 0.7rem"
        >
          <template #trigger>
            <button :class="$style['invite-trigger']" />
          </template>
        </invite-link>
      </div>
    </template>
    <template v-else>
      <h2>成功创建/加入任一队伍</h2>

      <!-- 创建队伍 -->
      <create-team ref="create-team" @login="$emit('login')" @create-success="showCreateSuccess" />

      <!-- 加入队伍 -->
      <join-team
        ref="join-team"
        @login="$emit('login')"
        @create-team="showCreateTeam"
        @join-success="showCreateSuccess"
      />

      <div
        style="
          position: absolute;
          top: 0.82rem;
          left: 0.95rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
        "
      >
        <icon-text
          v-for="(item, index) in createTeamReward"
          :key="index"
          :text="item.name"
          :icon="item.icon"
        />
      </div>
    </template>

    <!-- 创建队伍成功弹窗 -->
    <popup-frame ref="success-create" size="mini">
      <p style="margin-bottom: 0.5rem; font-size: 0.28rem; line-height: 1.8">
        恭喜您获得
        <em>{{ createTeamRewardName }}</em>
        ！ <br />请前往游戏内邮箱领取~
      </p>
      <div style="display: flex; align-items: center; justify-content: center; gap: 0.5rem">
        <icon-text
          v-for="(item, index) in createTeamReward"
          :key="index"
          :text="item.name"
          :icon="item.icon"
          size="lg"
        />
      </div>
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { IconText, PopupFrame } from '@/components/widgets'
import CreateTeam from '../CreateTeam'
import JoinTeam from '../JoinTeam'
import { fetchUserInfo } from '@/api'
import InviteLink from '../InviteLink'
import { getQueryString } from '@/utils'

export default {
  name: 'TeamInfo',
  components: {
    IconText,
    CreateTeam,
    JoinTeam,
    PopupFrame,
    InviteLink
  },
  computed: {
    ...mapGetters([
      'createTeamReward',
      'teamMemberList',
      'createTeamReward',
      'teamName',
      'teamSlogan'
    ]),
    createTeamRewardName() {
      return this.createTeamReward.map(item => item.name).join('、')
    }
  },
  watch: {
    teamName: {
      handler(newVal) {
        if (!newVal && getQueryString('code')) {
          setTimeout(() => {
            this.showJoinTeam()
          })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['setTeamInfo', 'updateAppData']),
    showCreateTeam() {
      this.$refs['create-team'].showCreateTeam()
    },
    showJoinTeam() {
      this.$refs['join-team'].showJoinTeam()
    },
    showCreateSuccess(data) {
      this.$refs['success-create'].show()
      this.setTeamInfo(data)
      this.initUser()
    },
    async initUser() {
      const { data = {} } = await fetchUserInfo()
      if (Object.keys(data).length > 0) {
        // 设置活动相关数据
        this.updateAppData(data)
      }
    }
  }
}
</script>

<style lang="less" module>
.team-info {
  position: relative;
  height: 2.65rem;

  h2 {
    padding-left: 1.4rem;
    font-size: 0.3rem;
    font-family: 'Source Han Serif SC Bold';
    line-height: 1.5;
    color: #fff;

    span {
      position: relative;
      top: -0.02rem;
      margin-left: 0.1rem;
      font-size: 0.18rem;
      font-family: 'Source Han Serif SC';
      line-height: 1.5;
      border-bottom: 1px solid #fff;
      opacity: 0.9;
    }
  }
}

.team-list {
  display: flex;
  justify-content: space-between;
  margin: 0.45rem 0.8rem 0;

  // 第一个icon-text添加徽章
  > div:first-child {
    position: relative;

    &::after {
      .size(0.56rem,0.26rem);
      .background-fill('./images/badge.png');

      content: '';
      position: absolute;
      top: 0.02rem;
      left: 0.02rem;
    }
  }
}

.invite-trigger {
  .size(1.42rem, 0.56rem);
  .background-fill('./images/invite-trigger.png');

  position: relative;
  top: -0.06rem;
}
</style>
